import { useEffect, useState } from "react";
import Loader from "../../components/Loader/Loader";
import CallServer from '../../api/api'
import DataTable from 'react-data-table-component';
import Form from 'react-bootstrap/Form';
import { NotificationManager } from 'react-notifications';

import './InitialScreen.css'

//Images
import plus_blue from '../../assets/images/plus_blue.svg'
import list_blue from '../../assets/images/list_blue.svg'
import EditorModal from "../../components/Modals/EditorModal";
import ApproveModal from "../../components/Modals/ApproveModal";

const AdminAppQA = [
    { button_name: "Search String", isReact:true ,link: "/string/search", button_icon: list_blue },
    { button_name: "Create New String", isReact:true , link: "/string/create", button_icon: plus_blue },
];

export default function InitialScreen () {

    const [isLoaded, setIsLoaded] = useState(true)
    const [availableTexts, setAvailableTexts] =  useState([])
    const [showApproveModal, setShowApproveModal] = useState(false)
    const [showSearchBar, setShowSearchBar] = useState(false)
    const [showEditModal, setShowEditModal] = useState(false)
    const [loading, setLoading] = useState(false);
    const [selectedKey, setSelectedKey] = useState(null)
    const [totalRows, setTotalRows] = useState(0);
    const [searchFilter, setSearchFilter] = useState({
        to_review: true,
        pattern: "",
        key: ""
    })
    const [perPage, setPerPage] = useState(10);

    const checkPermissions = async () => {
        const response = await CallServer.get_permissions()
        if(response.success){
            localStorage.setItem("i18n_user_permissions", JSON.stringify(response.data));
        } else {
            NotificationManager.error('Error while loading user permissions', 'Error')
        }
    }
    
    const loadAvailableTexts = async (page=1) => {
        let response = null
        if(searchFilter.pattern)
            response = await CallServer.search_text(searchFilter.pattern, (page-1)*perPage, perPage)
        else if(searchFilter.key)
            response = await CallServer.get_text(["it","en","es"], [searchFilter.key])
        else
            response = await CallServer.get_texts(searchFilter.to_review, (page-1)*perPage, perPage)
        if(response.success){
            if(searchFilter.key){
                setAvailableTexts([{
                    key: searchFilter.key,
                    texts: [
                        {
                            "language": "it",
                            "value": response?.data[searchFilter.key]?.it || ''
                        },
                        {
                            "language": "en",
                            "value": response?.data[searchFilter.key]?.en || ''
                        },
                        {
                            "language": "es",
                            "value": response?.data[searchFilter.key]?.es || ''
                        }
                    ]
                }])
            } else {
               setAvailableTexts(response.data) 
            }
            setTotalRows((page-1)*perPage + response.data.length);
            setLoading(false)
        } else {
            NotificationManager.error("Error while loading texts", "Oops")
        }
    }

    const handleSearch = () => {
        loadAvailableTexts()
    }

    const handlePageChange = async (page) => {
        loadAvailableTexts(page)
    }

    const handlePerRowsChange = async (newPerPage, page) => {
        setLoading(true);
        let response = null
        if(searchFilter.pattern)
            response = await CallServer.search_text(searchFilter.pattern, (page-1)*newPerPage, perPage)
        else if(searchFilter.key)
            response = await CallServer.get_text(["it","en","es"], [searchFilter.key])
        else
            response = await CallServer.get_texts(searchFilter.to_review, (page-1)*newPerPage, perPage)
        if(response.success){
            if(searchFilter.key){
                setAvailableTexts([{
                    key: searchFilter.key,
                    texts: [
                        {
                            "language": "it",
                            "value": response?.data[searchFilter.key]?.it || ''
                        },
                        {
                            "language": "en",
                            "value": response?.data[searchFilter.key]?.en || ''
                        },
                        {
                            "language": "es",
                            "value": response?.data[searchFilter.key]?.es || ''
                        }
                    ]
                }])
            } else {
               setAvailableTexts(response.data) 
            }
            setPerPage(newPerPage);
            setTotalRows((page-1)*perPage + response.data.length);
            setLoading(false);
        } else {
            NotificationManager.error("Error while loading texts", "Oops")
        }   
    };

    const handleChangeFilter = (event) => {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;
        
        setSearchFilter({
            ...searchFilter,
            [name]: value
        });
    }

    const resetFilter = (event) => {
        setSearchFilter({
            ...searchFilter,
            pattern: "",
            key: ""
        })
    }

    const openApproveModal = async (text_key) => {
        setSelectedKey(text_key)
        setShowApproveModal(true)
    }

    const openEditorModal = async (text_key) => {
        setSelectedKey(text_key)
        setShowEditModal(true)
    }

    const closeEditorModal = async () => {
        setSelectedKey(null)
        setShowEditModal(false)
    }

    const closeApproveModal = async () => {
        setSelectedKey(null)
        setShowApproveModal(false)
    }

    const toggleShowSearchBar = () => {
        setShowSearchBar(!showSearchBar)
    }

    useEffect(()=>{
        loadAvailableTexts()
        checkPermissions()
    },[])

    const packetsTableField = [
        {
            name: 'ID',
            selector: (row) => row.key || '',
            width: "24rem"
        },
        {
            name: 'IT String',
            selector: (row) => row.texts?.find(t=> t.language === "it")?.value || '',
            width: "18rem"
        },
        {
            name: 'EN String',
            selector: (row) => row.texts?.find(t=> t.language === "en")?.value || '',
            width: "18rem"
        },
        {
            name: 'ES String',
            selector: (row) => row.texts?.find(t=> t.language === "es")?.value || '',
            width: "18rem"
        },
        {
            name: 'EN String',
            cell: (row,index)  => <div className="d-flex">
                <button className="bg-success" onClick={()=>openApproveModal(row.key)}>Approve Text</button>
                <button className="ms-2" onClick={()=>openEditorModal(row.key)}>Edit</button>
            </div>,
            width: "18rem"
        },
    ]

    return (
        <div id="mainContent" >
            {isLoaded ?
                <div className="container mx-auto mt-5">
                    <h2>Quick access</h2>
                    <div className="menu">
                        <div className={"menu_item"} onClick={toggleShowSearchBar}>
                                <img src={list_blue} alt=""/>
                                <span>Search Text</span>
                        </div>
                        <div className={"menu_item"} onClick={()=>openEditorModal(null)}>
                                <img src={plus_blue} alt=""/>
                                <span>Create New Text</span>
                        </div>
                    </div>
                    {
                        showSearchBar &&
                        <>
                            <div className="input-group" >
                                <label>Key ID</label>
                                <input 
                                    className={`i18n_input`}
                                    name='key'
                                    value={searchFilter?.key || ''}
                                    onChange={handleChangeFilter}
                                />
                            </div>
                            <div className="input-group" >
                                <label>Search Pattern</label>
                                <input 
                                    className={`i18n_input`}
                                    name='pattern'
                                    value={searchFilter?.pattern || ''}
                                    onChange={handleChangeFilter}
                                />
                            </div>
                            <Form.Check // prettier-ignore
                                type="switch"
                                id="custom-switch"
                                name="to_review"
                                checked={searchFilter.to_review}
                                onChange={handleChangeFilter}
                                label="Text need review"
                            />
                            <div className='d-flex justify-content-end'>
                                <button className="bg-grey" onClick={resetFilter}>
                                    Reset Filter
                                </button>
                                <button className="ms-2" onClick={handleSearch}>
                                    Search
                                </button>
                            </div>
                        </>
                    }
                    <h2>Texts to review</h2>
                    <DataTable 
                        columns={packetsTableField}
                        data={availableTexts}
                        theme="default"
                        progressPending={loading} 
                        pagination 
                        paginationServer 
                        paginationTotalRows={totalRows + 1} 
                        onChangeRowsPerPage={handlePerRowsChange} 
                        onChangePage={handlePageChange} 
                    />
                    <EditorModal textKey={selectedKey} show={showEditModal} onRequestClose={closeEditorModal}/>
                    <ApproveModal textKey={selectedKey} show={showApproveModal} onRequestClose={closeApproveModal} />
                </div>
            : <Loader />}
        </div>
    )
}